import { render, staticRenderFns } from "./BillSettings.vue?vue&type=template&id=2c3b2ea8&scoped=true"
import script from "./BillSettings.vue?vue&type=script&lang=js"
export * from "./BillSettings.vue?vue&type=script&lang=js"
import style0 from "./BillSettings.vue?vue&type=style&index=0&id=2c3b2ea8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3b2ea8",
  null
  
)

export default component.exports